/* eslint-disable no-unused-vars */
import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';

import datastore from '@datastore';

import { getCloudinaryUrl } from '../../../utils/image';
import { personName } from '../../../utils/people_helpers';

import { TASK_ASSIGNMENT_STATUS } from '../../../utils/task';
import Avatar from '../../../components/avatar';
import './people_avatar_cell.scss';

export const PeopleAvatarCell = props => {
  const taskAssignmentsStatus = _.map(TASK_ASSIGNMENT_STATUS);
  const assignmentStatusCode = assignment => _.get(assignment, 'type_task_user_status.code');
  const assignmentStatusName = assignment => _.get(assignment, 'type_task_user_status.name');

  const hasStatus = (assignment, type) => assignmentStatusCode(assignment) === type;
  const getPersonNameFromAssingment = assignment =>
    personName(_.get(assignment, 'company_person', ''));

  const titleMessage = assignment => {
    const taskIsAssigned =
      taskAssignmentsStatus && _.includes(taskAssignmentsStatus, assignmentStatusCode(assignment));

    if (taskIsAssigned) {
      const fullName = getPersonNameFromAssingment(assignment);
      const userExpires = _.get(assignment, 'expires_at');

      if (assignmentStatusCode(assignment) === TASK_ASSIGNMENT_STATUS.PENDING && userExpires) {
        const timeToNow = moment().to(_.get(assignment, 'expires_at'));
        return `${fullName}: ${assignmentStatusName(assignment)} : Expires ${timeToNow}`;
      }
      return `${fullName}: ${assignmentStatusName(assignment)}`;
    }
    return null;
  };

  const wrapper = (value, children) =>
    _.size(value) > 2 || _.find(value, avatar => _.get(avatar, 'withWrapper', false)) ? (
      <div className="people-avatar__wrapper">{children}</div>
    ) : (
      children
    );

  const avatars = (
    <div className="people-avatar rt-td--default justify-content-start">
      {_.map(props.value, (assignment, index) => {
        const companyPerson = _.get(assignment, 'company_person');

        return (
          <Avatar
            accepted={hasStatus(assignment, TASK_ASSIGNMENT_STATUS.ACCEPTED)}
            declined={hasStatus(assignment, TASK_ASSIGNMENT_STATUS.DECLINED)}
            expired={hasStatus(assignment, TASK_ASSIGNMENT_STATUS.EXPIRED)}
            key={index}
            name={getPersonNameFromAssingment(assignment)}
            pending={hasStatus(assignment, TASK_ASSIGNMENT_STATUS.PENDING)}
            title={titleMessage(assignment)}
            person={companyPerson}
          />
        );
      })}
    </div>
  );

  return wrapper(props.value, avatars);
};

PeopleAvatarCell.propTypes = {
  value: PropTypes.arrayOf(PropTypes.shape({})),
};

export default PeopleAvatarCell;
